const Bar = ({
  precentage,
  height,
  backgroundColor,
  width,
  isCount,
  total,
  finished,
  barColor,
  textColor,
  raduis,
  containerStyle,
}) => {
  const barWidth = precentage
    ? precentage
    : (finished / (total == 0 ? 1 : total)) * 100;
  return (
    <div
      style={{
        width: width ? width + "%" : "50%",
        height: height ?? 40,
        borderRadius: raduis ?? 25,
        backgroundColor: backgroundColor ?? "#F2F2F2",
        position: "relative",
        zIndex: -1,
      }}
      className={`${containerStyle}`}
    >
      <div
        style={{
          color: textColor,
          position: "absolute",
          bottom: 0,
          top: 0,
          left: 0,
          right: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {precentage ?? 0} %
      </div>
      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          width: `${barWidth}%`,
          backgroundColor: barColor ?? "#3EC4B8",
          height: "inherit",
          borderRadius: 30,
        }}
      >
        {!precentage && isCount ? (
          <div style={{ color: textColor }}>
            {finished ?? 0}/{total}
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default Bar;
